module.exports = __webpack_public_path__ + "static/media/mena.168016be.png";